var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Complaint',{attrs:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }